import React from 'react';
import { Button, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import styles from './ServiceProductListItem.module.scss';
import { useTranslation } from 'react-i18next';

interface ServiceProductListItemProps {
    item: any;
}

const ServiceProductListItem: React.FC<ServiceProductListItemProps> = ({ item }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	// 获取美国州列表
	const StateList = useAppSelector((state) => state.common.StateList);

	// 处理紧急服务订单数据结构
	const isEmergencyService = item?.emergency_service_id !== undefined;
	
	if (isEmergencyService) {
		// 紧急服务订单数据结构
		const imageUrl: string = item?.images && item.images.length > 0 ? item.images[0].product_media_file_url : '';
		const title: string = item?.problem_description || 'Service Request';
		const appointmentTime: string = item?.appointment_time || 'N/A';
		const problemDesc: string = item?.problem_description || 'No description available';
		const distanceText: string = item?.distance ? `${item.distance.toFixed(2)} Miles From You` : 'Distance N/A';
		const price: number = item?.fixed_price || item?.budget || 0;
		const address: string = item?.address || 'Address N/A';
		const cityState: number = item?.city_state;

		return (
			<div className={styles['product-item']}>
				<div 
					className={styles['product-item-top']} 
					onClick={() => navigate(`/EmergencyServiceDetail/${item?.emergency_service_id}`)}>
					<img className={styles['product-item-top-img']} src={imageUrl} alt={title} />
					{distanceText ? <div className={styles['distance-badge']}>{item?.distance ? `${item.distance.toFixed(2)} ${t('searchList.MilesFromYou')}` : `${t('searchList.Distance')} N/A`}</div> : null}
				</div>
				<div className={styles['product-item-bottom']}>
					<div className={styles['product-item-bottom-title']} title={title}>{item?.problem_description || t('searchList.ServiceRequest')}</div>
					<div className={styles['info-row']}>
						<span className={styles['label']}>{t('searchList.Address')}:</span>
						<span className={styles['value']}>
							{address ? (address.slice(0, 10) + '****') : `${t('searchList.Address')} N/A`}
							{StateList && StateList.length > 0 && (() => {
								const stateItem = StateList.find((stateItem: any) => 
									stateItem.value === cityState || 
									StateList.indexOf(stateItem) === cityState - 1
								);
								return stateItem ? `, ${stateItem.label}` : '';
							})()}
						</span>
					</div>
					<div className={styles['info-row']}>
						<span className={styles['label']}>{t('searchList.AppointmentTime')}:</span>
						<span className={styles['value']}>{appointmentTime}</span>
					</div>
					<div className={styles['info-row']}>
						<span className={styles['label']}>{t('searchList.ProblemDescription')}:</span>
						<span className={styles['desc']} title={problemDesc}>{item?.problem_description || t('searchList.Nodescriptionavailable')}</span>
					</div>
					<div className={styles['info-row']}>
						<span className={styles['label']}>{t('searchList.Price')}:</span>
						<span className={styles['price']}>${price}</span>
					</div>
					{window.location.pathname !== '/searchList' && (
					<div className={styles['actions']}>
						<Tag>{t('searchList.Bidding')}</Tag>
						<Tag>{t('searchList.FixedPrice')}</Tag>
						</div>
					)}
					</div>
			</div>
		);
	}

	// 原有的服务产品数据结构（保持兼容性）
	const imageUrl: string = item?.product_main_images?.[0]?.media_file_url || '';
	const title: string = item?.service_product_value?.service_name || '';
	const appointmentTime: string[] = item?.service_product_value?.reservation_time_slots || [];
	const problemDesc: string = item?.service_product_value?.service_description || 'The Bathroom Pipe Is Clogged';
	const distanceText: string | null = ((): string => {
		if (typeof item?.distance_text === 'string') return item.distance_text;
		if (typeof item?.distance === 'number') return `${item.distance} Miles From You`;
		return ""
	})();
	const priceNumber: string | number = item?.sales_specifications?.[0]?.price || '0';
	const currencySymbol: string = item?.currency_symbol ?? '$';

	return (
		<div className={styles['product-item']}>
			<div 
				className={styles['product-item-top']} 
				onClick={() => navigate(`/ServiceProductDetail/${item?.service_product_value?.service_id}`)}>
				<img className={styles['product-item-top-img']} src={imageUrl} alt={title} />
				{distanceText ? <div className={styles['distance-badge']}>{typeof item?.distance_text === 'string'? item.distance_text :
		typeof item?.distance === 'number' ? `${item.distance} ${t('searchList.MilesFromYou')}`:""}</div> : null}
			</div>
			<div className={styles['product-item-bottom']}>
				<div className={styles['product-item-bottom-title']} title={title}>{title}</div>
				<div className={styles['info-row']}>
					<span className={styles['label']}>{t('searchList.AppointmentTime')}:</span>
					<span className={styles['value']}>{appointmentTime.length && appointmentTime.join(',')}</span>
				</div>
				<div className={styles['info-row']}>
					<span className={styles['label']}>{t('searchList.ServiceDescription')}:</span>
					<span className={styles['desc']} title={problemDesc}>{item?.service_product_value?.service_description || t('searchList.TheBathroomPipeIsClogged')}</span>
				</div>
				<div className={styles['info-row']}>
					<span className={styles['label']}>{t('searchList.Price')}:</span>
					<span className={styles['price']}>${priceNumber}</span>
				</div>
				{window.location.pathname !== '/searchList' && (
					<div className={styles['actions']}>
						<Tag>{t('searchList.Bidding')}</Tag>
						<Tag>{t('searchList.FixedPrice')}</Tag>
					</div>
				)}
			</div>
		</div>
	);
};

export default ServiceProductListItem; 